import type { PropsWithChildren } from "react";

import { Navigate, useLocation } from "react-router";

import { useGetProfile } from "@/api/bale";

export function ProtectedRoute({ children, invert = false }: PropsWithChildren<{ invert?: boolean }>) {
  const { status, error } = useGetProfile("@me");
  const location = useLocation();

  const isSuccess = status === "success";
  const isUnauthorized = status === "error" && error.info?.code === "Unauthorized";

  if (invert ? isUnauthorized : isSuccess) {
    return <>{children}</>; // oxlint-disable-line jsx-no-useless-fragment
  } else if (invert ? isSuccess : isUnauthorized) {
    const search = new URLSearchParams(location.search);
    const where = invert ? (search.get("next") ?? "/overview") : `/join?next=${location.pathname}`;
    return <Navigate to={where} replace />;
  } else if (error) {
    throw error;
  } else {
    return null;
  }
}
